import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TableColumn } from 'shared-ui/lib/customs/react/generic-table/TableColumn';
import { routesConfig } from '../config/routes.config';
import { GroupIndexSceneQuery } from '../generated/graphql';
import { getGroupDisplayName } from '../utils/get-group-display-name';

type GroupRow = GroupIndexSceneQuery['groups']['list'][0];

const name: TableColumn = {
  field: 'name',
  text: 'Group:name',
  formatter: (data: GroupRow) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation();
    return getGroupDisplayName(data, t);
  },
};

const notificationEmail: TableColumn = {
  field: 'notificationEmail',
  text: 'Group:notificationEmail',
  tdClassNames: 'text-gray-color',
  formatter: (data: GroupRow) => data.notificationEmail || '-',
};

const vehicleCount: TableColumn = {
  field: 'vehicleCount',
  text: 'Group:vehicles',
  tdClassNames: 'text-gray-color',
};

const userCount: TableColumn = {
  field: 'userCount',
  text: 'Group:users',
  tdClassNames: 'text-gray-color',
};

const linkToGroup: TableColumn = {
  field: 'id',
  text: 'General:link',
  formatter: (data: GroupRow) => (
    <Link
      to={routesConfig.SETTINGS.GROUPS.EDIT.replace(':id', data.id)}
      className="hover:text-primary text-gray-color"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14 5l7 7m0 0l-7 7m7-7H3"
        />
      </svg>
    </Link>
  ),
};

export const groupColumns = {
  name,
  notificationEmail,
  vehicleCount,
  userCount,
  linkToGroup,
};
